<template>
  <div class="app">
    <AppHeader />
    <SubHeader />
    <div class="app-body">
      <div v-if="$store.getters.roleID === Roles.ADMIN">
        <Sidebar :nav-items="navAdmin" />
      </div>
      <div v-if="$store.getters.roleID === Roles.SUPER_ADMIN">
        <Sidebar :nav-items="nav" />
      </div>
      <div v-if="$store.getters.roleID === Roles.MAINTENANCE">
        <Sidebar :nav-items="navMaintenanceManager" />
      </div>
      <div v-if="$store.getters.roleID === Roles.INSURANCE">
        <Sidebar :nav-items="navInsuranceManager" />
      </div>
      <div v-if="$store.getters.roleID === Roles.ANALYTICS">
        <Sidebar :nav-items="navAnalytics" />
      </div>
      <div v-if="$store.getters.roleID === Roles.EXT_OPS">
        <Sidebar :nav-items="navExternalOperations" />
      </div>
      <div v-if="$store.getters.roleID === Roles.DEVICE_CONFIGURATION_MANAGER">
        <Sidebar :nav-items="navDeviceConfigurationManager" />
      </div>
      <main class="main bg-white">
        <div class="container-fluid">
          <router-view :key="$route.fullPath" />
        </div>
      </main>
    </div>
    <StatusBar />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import nav from '../_nav'
import { EventBus } from '@/event-bus.js'
import { Header as AppHeader, Sidebar, Breadcrumb, SubHeader, StatusBar } from '../views/components/'
import * as Routes from '../constants/routes.js'
import * as Roles from '../constants/roles.js'

export default {
  name: 'Full',
  components: {
    AppHeader,
    Sidebar,
    Breadcrumb,
    SubHeader,
    StatusBar
  },
  data () {
    return {
      nav: nav.items,
      navAdmin: nav.itemsAdmin,
      navAnalytics: nav.itemsAnalytics,
      navExternalOperations: nav.itemsExternalOperations,
      navMaintenanceManager: nav.itemsMaintenanceManager,
      navInsuranceManager: nav.itemsInsuranceManager,
      navDeviceConfigurationManager: nav.itemsDeviceConfigurationManager,
      Roles: Roles
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched
    },
    tenants () {
      return this.$store.state.tenantsList.data
    },
    ...mapGetters([
      'roleID'
    ])
  },
  mounted () {
    this.$store.dispatch('fetchTenants')

    EventBus.$on('invalid-token', () => {
      // token has expired - log out
      this.$store.dispatch('logout')
      this.$router.push(Routes.LOGIN)
    })
    EventBus.$on('TOKEN is not valid', () => {
      // token has expired - log out
      this.$store.dispatch('logout')
      this.$router.push(Routes.LOGIN)
    })
  }
}
</script>